<template>
    <span class="sale-type">{{ label }}</span>
</template>

<script>
export default {
    name: 'SaleTypeBadge',
    props: {
        label: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.sale-type {
    display: inline-block;
    padding: 3px 7px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    background: #fff;
    color: #6b7280;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
}
</style>
